import { errorMessaging } from "../../market-dynamics/constants";
import { getOfficeListingsBreakdown, getMarketDynamicsOfficeBreakdown, getMarketDynamicsSearch, getListingsBreakdownByOffice } from "../../service/market-dynamics";

/**
 * @deprecated This actions need to be moved to search store.
 */
export const actionsDeprecated = (set, get) => ({
    setTableView: ({ tableView }) => {
        set({ tableView });
    },
    setSelectedBreakdownPeriod: (selectedBreakdownPeriod) => {
        set({ selectedBreakdownPeriod });
    },
    getOfficesBreakdown: async (searchCriteria) => {
        try {
            const offices = await getMarketDynamicsOfficeBreakdown(searchCriteria);
            if (offices.error) throw new Error(errorMessaging.getFetchErrorMsg('offices'));
            return offices;
        } catch(e) {
            console.error(e);
        }
    },
    getListingsBreakdown: async (searchCriteria, status, isOfficeListing, officeId) => {
        try {
            const getListings = async () => {
                if (isOfficeListing && officeId) {
                    return await getListingsBreakdownByOffice(searchCriteria, status, officeId);
                }
                return await getOfficeListingsBreakdown(searchCriteria, status);
            };
            const listings = await getListings();
            if (listings?.error) {
                console.error(`${errorMessaging.getFetchErrorMsg('listings')}`);
                return [];
            };
            return listings;
        } catch(e) {
            console.error(e);
        }
    },
    setCheckedStatusOptions: (options) => set({ checkedStatusOptions: [...options] }),
    runMarketDynamicsSearch: async criteria => {
        try {
            const { results, totals, error = undefined } = await getMarketDynamicsSearch(criteria);

            if (error) throw new Error (error);
            return {
                results,
                totals
            };
        } catch(e) {
            throw new Error (e?.message ?? e)
        }
    },
    setListingViewId: (listingViewId) => set({ listingViewId}, false, 'setListingViewId'),
    setOverviewStatusKey: (key, value) => {
        const { overviewStatus } = get();
        if (!(key in overviewStatus)) console.error(`Key "${key}" does not exist in overviewStatus.`);
        set((state) => ({
            overviewStatus: {
                ...state.overviewStatus,
                [key]: value,
            },
        }), false, 'setOverviewStatusKey');
    },
    setMarketIndicatorContent: (marketIndicatorContent) => set({ marketIndicatorContent }, false, 'setMarketIndicatorContent'),
});
